import {
  DefaultEntityFilters,
  EntityAutocompletePicker,
  EntityFilter,
} from '@backstage/plugin-catalog-react';
import { ANNOTATION_USER_DEPARTMENT } from '@appfolio/backstage-plugin-catalog-common';

const FACET = `metadata.annotations.${ANNOTATION_USER_DEPARTMENT}`;

class EntityUserDepartmentFilter implements EntityFilter {
  public constructor(readonly values: string[]) {}

  public getCatalogFilters(): Record<string, string | string[]> {
    return { [FACET]: this.values };
  }

  public toQueryValue(): string[] {
    return this.values;
  }
}

export const EntityUserDepartmentPicker = () => (
  <EntityAutocompletePicker<
    DefaultEntityFilters & {
      userDepartment: EntityUserDepartmentFilter;
    }
  >
    label="Department"
    name="userDepartment"
    path={FACET}
    Filter={EntityUserDepartmentFilter}
  />
);
